// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"350":"e1e6cb634d67fddd00ec","374":"6a82a4f46d31e46cb4cb","660":"7894c27ac04360b7c010","826":"bef4b1ddd0a43e08dfea","896":"63af38d371d2df8e24b2"}[chunkId] + ".bundle.js";
};